import {Box} from "@mui/material";
import React from "react";

const NoTicketsError: React.FC = () => {
    return (
        <Box
            sx={{
                height: {
                    xs: "calc(100vh - 412px)",
                    sm: "calc(100vh - 290px)",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                },
            }}
        >
            No Tickets Found
        </Box>
    );
};

export default NoTicketsError;
